import { RootState } from '../../..'
import { UserOrganizationEducationalContent } from '../../../../types/user'

export const selectOrgSettingsOrganizationDetails = (state: RootState): any =>
	state.appReducer?.orgSettings?.organization || {}

export const selectOrgSettingsOrganizationEducationalContent = (
	state: RootState
): Array<UserOrganizationEducationalContent> =>
	state.appReducer?.orgSettings?.organization
		?.educationalContent || []
